import React, {FC, useState} from "react";

import PageHeader from "components/PageHeader";
import IDPayOverview from "./IDPayOverview";
import { ReactComponent as IDPayIcon } from "assets/img/icons/Verification/Icons.svg";
import { DocumentUnion } from "shared/types/types";
import TabContent from "components/TabContent";
import Tabs from "shared/ui/Tabs";
import { ReactComponent as IconFaq } from "assets/img/icons/icon_Faq.svg";

const iconProps = {
    fill: "#2f62ae",
    width: "40px",
};

const iconProps2 = {
    fill: "#2f62ae",
    width: "20px",
};


const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const columns = [
    { key: "nationality", label: "" },
    { key: "type", label: "Type de document" },
    { key: "number", label: "Numéro" },
    { key: "createdAt", label: "Date de l'ajout" },
    { key: "status", label: "Statut" },
    { key: "isBlocked", label: "" },
];

const IDPayDashboard: FC = () => {

    const [selectedRows, setSelectedRows] = useState<DocumentUnion[]>([]);

    // Initialisation avec la valeur du localStorage (par défaut: true si non défini)
    const [showOverview, setShowOverview] = useState<boolean>(() => {
        // TODO : A décomenter pour faire marcher Video Prsentation
        const storedValue = localStorage.getItem("IDPayOverview");
        return storedValue !== null ? JSON.parse(storedValue) : true;
        // return false;
    });

    const [isLoading, setIsLoading] = useState(true);

    const handleSelectionChange = (rows: DocumentUnion[]) => {
        setSelectedRows(rows);
    };

    const tabs = [
        {
            label: "Tous",
            notification: false,
            content: (
                <TabContent
                    documents={[]}
                    selectedRows={selectedRows}
                    onSelectionChange={handleSelectionChange}

                />
            ),
        },
        {
            label: "reussi",
            notification: false,
            content: (
                <TabContent
                    documents={[]}
                    selectedRows={selectedRows}
                    onSelectionChange={handleSelectionChange}

                />
            ),
        },
        {
            label: "echec",
            notification: false,
            content: (
                <TabContent
                    documents={[]}
                    selectedRows={selectedRows}
                    onSelectionChange={handleSelectionChange}

                />
            ),
        },
    ];


    return (
        <>
            <PageHeader>
                <h5>ID Pay</h5>
                <IDPayIcon className="PageHeader__icon" {...iconProps} />
            </PageHeader>
            {showOverview ?
                (
                    <IDPayOverview
                        setShowOverview={setShowOverview}
                        showOverview={showOverview}
                    />
                )
                :
                (
                    <div className="IDPayDashboard content__body">
                        <Tabs tabs={tabs} />
                        <div className="mt-2 mb-1">
                            <div
                                className="d-flex justify-content-center align-items-center gap-05">
                                <u className="pointer font-SM"
                                   onClick={() => {
                                       setShowOverview(true);
                                   }}>Découvrez-vous le fonctionnement d'ID Pay</u>
                                <IconFaq {...iconProps2} />
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default IDPayDashboard;
